module.exports = __webpack_public_path__ + "49f029d5cb282dcb8e7921819ac83ecf.svg";